import React, { PropsWithChildren } from "react";
import ReactDOM from "react-dom";

import { Container } from "./MapOverlay.styles";

const MapOverlay: React.FC<PropsWithChildren> = ({ children }: PropsWithChildren) => {
  const mapElement = document.getElementById("mapContainer");

  const render = () => <Container>{children}</Container>;

  if (!mapElement) return render();

  /**
   * We use a portal to move the MapOverlay component within the Map
   * DOM Object. This allows the overlay to be used within any component
   * and DOM tree.
   */
  return ReactDOM.createPortal(render(), mapElement);
};

export default MapOverlay;
